module.exports = __webpack_public_path__ + "static/media/child-1111818_640.9518d5cd.jpg";